module.exports = __webpack_public_path__ + "static/media/mxnb.82214ff7.svg";